import SelectAllButton from '../../common/components/List/SelectAllButton.js'
import {
  setSelectedReferenceIDs,
  referenceIDListSelector,
  indeterminateSelectedSelector,
  allSelectedSelector,
} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

export default function StocktakeSelectAllButton() {
  const referenceIDList = useSelector(referenceIDListSelector)
  const indeterminate = useSelector(indeterminateSelectedSelector)
  const checked = useSelector(allSelectedSelector)

  return (
    <SelectAllButton
      checked={checked}
      indeterminate={indeterminate}
      onChange={(value) =>
        setSelectedReferenceIDs(value ? referenceIDList : [])
      }
    />
  )
}
